// extracted by mini-css-extract-plugin
module.exports = {"page":"Matches_page__2e2_2","header":"Matches_header__1WEHm","body":"Matches_body__3aoCl"};